import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import SupportServiceTagListForm from '@src/features/tenant/supportServices/tags/SupportServiceTagList';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function SupportServiceTagList() {
  return (
    <TenantRoleGuard
      canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT]}
      canService={[SERVICE.ENTERPRISE_PORTAL, SERVICE.DX_DIAGNOSIS]}
    >
      <TenantDefaultLayout>
        <CommonHelmet />
        <SupportServiceTagListForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default SupportServiceTagList;
